import React, { Component } from "react";
import clsx from 'clsx';
import { makeStyles, withStyles, useTheme, styled } from '@material-ui/core/styles';
import Save from '../../../../assets/img/svg/save.svg';
import Cancel from '../../../../assets/img/svg/cancel.svg';
import Delete from '../../../../assets/img/svg/delete.svg';
import { Tabs, Tab, AppBar, Typography, Box } from '@material-ui/core';
import PropTypes from 'prop-types';
import EditOPA_Detail from './EditOPA-Detail'
import EditOPA_Historylog from './EditOPA-Historylog'
import del from "../../../../assets/img/svg/Del.svg"
import withRouter from "../../../custom/withRouter";
import { connect } from "react-redux";
import List from '@material-ui/core/List';
import NavigateNextIcon from '@material-ui/icons/NavigateNext';
import Divider from '@material-ui/core/Divider';
import ListItem from '@material-ui/core/ListItem';
import ListItemText from '@material-ui/core/ListItemText';
import styles from "../../../../assets/jss/customStyle";
import { useNavigate } from "react-router-dom";
import Autocomplete from "react-autocomplete";
import $ from 'jquery';
import {
    TextField, FormControlLabel, Radio, Checkbox,
    Select, MenuItem, InputBase, Chip, Input, Button, InputAdornment,
    IconButton, FormHelperText, FormControl, RadioGroup
} from '@material-ui/core';
import axios from "axios";
import { getlookupdocinfo } from "../../../../actions/MasterDataAction";
import { editOPA, getOPAActivity, geteditopainfo } from "../../../../actions/OPAAction";
import API from "../../../../_helpers/endpointService";
import moment from "moment"
import { putOPA, getOPA_ListView, deleteOPA, gethistorylogOPA } from "../../../../actions/OPAAction";
import { getSettingsFormat } from "../../../../actions/SettingsAction";

function TabPanel(props) {
    const { children, value, index, ...other } = props;

    return (
        <div
            role="tabpanel"
            hidden={value !== index}
            id={`full-width-tabpanel-${index}`}
            aria-labelledby={`full-width-tab-${index}`}
            {...other}
        >
            {value === index && (
                <Box p={3}>
                    <Typography>{children}</Typography>
                </Box>
            )}
        </div>
    );
}
TabPanel.propTypes = {
    children: PropTypes.node,
    index: PropTypes.any.isRequired,
    value: PropTypes.any.isRequired,
};
function a11yProps(index) {
    return {
        id: `full-width-tab-${index}`,
        'aria-controls': `full-width-tabpanel-${index}`,
    };
}

class EditOPA extends Component {
    constructor(props) {
        super(props)
        this.state = {
            isMobile: false,
            value: 0,
            "ActivityError": false,
            "PlannedDateError": false,
            "ReasonsForDeviationError": false,
            ProjectId: 0,
            cancel: false,
            count: 1000,
            addData: {
                "Id": 0,
                "ProjectId": 0,
                "PlannedDate": "",
                "CompletionDate": null,
                "Activity": "",
                "Comments": "",
                "ReasonsForDeviation": "",
                "ModifiedBy": ""
            }
        }
    }

    componentDidMount() {
        this.state.addData.ProjectId = parseInt(localStorage.getItem("DashId"));
        this.state.addData.ModifiedBy = localStorage.getItem("UserRoles");
        this.state.addData.Id = parseInt(localStorage.getItem("OPAEditId"))
        this.state.ProjectId = parseInt(localStorage.getItem("DashId"));
        this.props.dispatch(getSettingsFormat(this.state.addData.ProjectId))
        this.props.dispatch(getlookupdocinfo("Operation"))
        this.geteditopainfo(this.state.addData.Id)
        this.setState({})
        window.addEventListener("resize", this.resize.bind(this));
        this.resize()
        this.interval = setInterval(() => {
            this.resize1()
        }, 10);
    }

    componentWillUnmount() {
        clearInterval(this.interval);
        window.removeEventListener("resize", this.resize.bind(this));
        $("#OPE1 .MuiListItemText-primary").addClass("spanTopBar");
        $("#Operation1 .MuiListItemText-primary").removeClass("fw-bolder");
        $("#Operation").addClass("d-none");
        $("#Operation").removeClass("d-block");
        $("#OPAL").removeClass("active-color");
        $("#OPAT").removeClass("fw-bolder");
    }

    resize = () => {
        if (window.innerWidth < 850) {
            this.setState({
                isMobile: true
            })
        }
        else {
            this.setState({
                isMobile: false
            })
        }
    };

    resize1 = () => {
        $("#OPE1 .MuiListItemText-primary").addClass("spanTopBar");
        $("#Operation1 .MuiListItemText-primary").addClass("fw-bolder");
        $("#Operation").removeClass("d-none");
        $("#Operation").addClass("d-block");
        $("#OPAL").addClass("active-color");
        $("#OPAT").addClass("fw-bolder");
    }

    handleChange = (event, newValue) => {
        this.setState({
            value: newValue,
        })
        if (this.state.value == 1) {
            // this.geteditopainfo(this.state.addData.Id)
        }
        if (this.state.value == 0) {
            this.props.dispatch(gethistorylogOPA(this.state.ProjectId))
        }
    };

    sidebar = () => {
        if (this.state.cancel === true) {
            window.$("#cancelpopup1").modal("show");
        }
        else {
            this.props.navigate("/sidebar");
        }

    };
    SideBarCancel = () => {
        this.props.dispatch({ type: "CANCEL", data: false });
        window.$("#cancelpopup1").modal("hide");
        this.props.navigate("/sidebar");
    }
    geteditopainfo = (id) => {
        let apiUrl = API.OPA_LISTVIEW + '/' + id
        this.props.dispatch({ type: "SHOW_LOADER", data: true })
        axios({
            method: "GET",
            url: apiUrl,
        })
            .then((response) => {
                if (response?.status === 200) {
                    this.props.dispatch({ type: "OPAEDIT_DOCS", data: response.data });
                    this.state.addData.Activity = response.data.Activity;
                    this.state.addData.PlannedDate = response.data.PlannedDate;
                    this.state.addData.CompletionDate = response.data.CompletionDate;
                    this.state.addData.ReasonsForDeviation = response.data.ReasonsForDeviation;
                    this.state.addData.Comments = response.data.Comments;
                    this.setState({})
                    this.props.dispatch({ type: "SHOW_LOADER", data: false })
                } else {
                    this.props.dispatch({ type: "SHOW_LOADER", data: false })
                }
            })
            .catch((error) => {
                this.props.dispatch({ type: "SHOW_LOADER", data: false })
                if (error?.response?.status === 401) {
                }
            });
    };

    renderProjectNames = (state, val) => {
        return state?.Name?.toLowerCase().indexOf(val?.toLowerCase()) !== -1;
    };
    handleInputChange = (e, node) => {
        this.props.dispatch({ type: "CANCEL", data: true });
        this.state.cancel = true;
        this.state.addData[node] = e.target.value;
        this.setState({});
    };

    handleCommentChange = (e, node) => {
        this.state.cancel = true;
        this.props.dispatch({ type: "CANCEL", data: true });
        if (node == "Comments") {
            if (e.target.value.length - 1 < 1000) {
                this.state.addData[node] = e.target.value;
                this.setState({});
            }
        }
        else {
            if (e.target.value.length - 1 < 500) {
                this.state.addData[node] = e.target.value;
                this.setState({});
            }
        }
    };

    handleDateChange = (e, node) => {
        this.state.cancel = true;
        this.props.dispatch({ type: "CANCEL", data: true });
        this.state.addData[node] = e.target.value
        this.setState({});
    };
    handleProjectNameSearchChange = (e) => {
        this.state.cancel = true;
        this.props.dispatch({ type: "CANCEL", data: true });
        this.state.addData.Activity = e.target.value;
        this.setState({});
    };
    handleProjectNameSelectChange = (e) => {
        this.state.cancel = true;
        this.props.dispatch({ type: "CANCEL", data: true });
        this.state.addData.Activity = e;
        this.setState({});
    };
    DeleteItem = () => {
        this.state.addData.Id = parseInt(localStorage.getItem("OPAEditId"))
        this.props.dispatch(deleteOPA(this.state.addData.Id, this.state.addData.ModifiedBy))
        this.props.navigate("/operationplanningachievements")
    }
    EditCancel = () => {
        this.props.dispatch({ type: "CANCEL", data: false });
        window.$("#cancelpopup").modal("hide");
        this.props.navigate("/operationplanningachievements")
    };

    EditCancelarrow = () => {
        if (this.state.value == 1) {
            this.state.value = 0
            this.setState({})
            this.geteditopainfo(this.state.addData.Id)
        }
        else {
            if (this.state.cancel == true) {
                window.$("#cancelpopup").modal("show");
            }
            else {
                this.props.dispatch({ type: "CANCEL", data: false });
                this.props.navigate("/operationplanningachievements")
            }
        }
    };

    EditSave = () => {
        const { Activity, PlannedDate, ReasonsForDeviation, CompletionDate } = this.state.addData;
        if (Activity.trim() === "") {
            this.state.ActivityError = true;
            this.state.addData.Activity = this.state.addData.Activity.trim();
            this.setState({})
        }
        else {
            this.state.ActivityError = false;
            this.state.addData.Activity = this.state.addData.Activity.trim();
            this.setState({})

        }

        if (PlannedDate === "") {
            this.state.PlannedDateError = true;
            this.setState({})
        }
        else {
            this.state.PlannedDateError = false;
            this.setState({})
        }
        if (CompletionDate !== null) {
            if (ReasonsForDeviation.trim() == "") {
                this.state.ReasonsForDeviationError = true;
                this.state.addData.ReasonsForDeviation = this.state.addData.ReasonsForDeviation.trim();
                this.setState({})
            }
            else {
                this.state.ReasonsForDeviationError = false;
                this.state.addData.ReasonsForDeviation = this.state.addData.ReasonsForDeviation.trim();
                this.setState({})
            }
        }
        if (this.state.addData.Activity !== '' && PlannedDate !== '' && (!CompletionDate || (CompletionDate && this.state.addData.ReasonsForDeviation !== ''))) {
            this.props.dispatch({ type: "CANCEL", data: false });
            if (this.state.addData.Comments != null) {
                this.state.addData.Comments = this.state.addData.Comments.trim();
                this.setState({})
            }
            this.setState({})
            this.putOPA(this.state.addData, this.state.addData.Id)
        }
        else {
        }
    }
    putOPA = (data, id) => {
        if (data.CompletionDate == "") {
            data.CompletionDate = null;
        }
        let apiUrl = API.OPA_LISTVIEW + '/' + id;
        this.props.dispatch({ type: "SHOW_LOADER", data: true })
        axios({
            method: "PUT",
            url: apiUrl,
            data: data,
        })
            .then((response) => {
                this.props.dispatch({ type: "SHOW_LOADER", data: false })
                if (response?.status === 200) {
                    this.props.navigate("/operationplanningachievements")
                } else {
                    this.props.dispatch({ type: "SHOW_LOADER", data: false })
                }
            })
            .catch((error) => {
                this.props.dispatch({ type: "SHOW_LOADER", data: false })
                if (error?.response?.status === 401) {
                }
            });
    };

    render() {
        let { classes, menuToggle, OPA_Actvity } = this.props;
        return (
            <>
                {
                    this.state.isMobile ?
                        <>
                            <div className="row w-100 mt-4">
                                <div className="col-6 mt-auto">
                                    <List className="pt-4 mt-4 " style={{ backgroundColor: "#F6F6F6" }}>
                                        <ListItem onClick={this.sidebar} >
                                            <ListItemText id={"OPE" + "1"} className='  textNaviIcon' primary="Daily Tasks" />
                                            <NavigateNextIcon id="OPE" className="naviIcon ml-1" style={{ width: 23, height: 23 }} />
                                            <Divider className='border-bottom' />
                                        </ListItem>
                                    </List>
                                </div>
                                <div className="col-6 pt-2 mt-5">
                                    <h4>Edit Operation Planning & Achievement</h4>
                                </div>
                            </div>
                        </>
                        :
                        <></>
                }
                <div className="ml-auto scroll-hide" style={{ backgroundColor: "#FFFFFF", width: this.state.isMobile ? "100%" : menuToggle ? "calc(100% - 240px)" : "calc(100% - 64px)", marginTop: this.state.isMobile ? '' : -95 }}>
                    {this.state.isMobile ?
                        <table className="dataTable border-top" width="100%">
                            <tbody>
                                <tr>
                                    <td width="5%" className="border-right text-center">
                                        <i class="fa fa-arrow-left cursorPointer" onClick={() => { this.EditCancelarrow() }}></i>
                                    </td>
                                    <td className={this.state.value == 0 ? "border-right text-center" : ""}>
                                        {this.state.value == 0 ?
                                            <span className={classes.button} style={{ minWidth: '60px' }} onClick={this.EditSave}><img src={Save} style={{ marginTop: '-4px' }}></img>&nbsp;Save</span> : <></>}
                                    </td>
                                    <td className={this.state.value == 0 ? "border-right text-center" : ""}>
                                        {this.state.value == 0 ?
                                            <span className={`${classes.button} `} style={{ minWidth: '70px' }} onClick={() => { this.EditCancelarrow() }}><img src={Cancel} style={{ marginTop: '-4px' }}></img>&nbsp;Cancel</span> : <></>}
                                    </td>
                                    <td className={this.state.value == 0 ? " text-center" : ""}>
                                        {this.state.value == 0 ?
                                            <span className={`${classes.button} `} style={{ minWidth: '70px' }} data-target="#deletepopup" data-toggle="modal" ><img src={Delete} style={{ marginTop: '-4px' }}></img>&nbsp;Delete</span> : <></>}
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                        : <table className="dataTable" width="100%">
                            <tbody>
                                <tr>
                                    <td width="5%" className="border-right text-center">
                                        <i class="fa fa-arrow-left cursorPointer" onClick={() => { this.EditCancelarrow() }}></i></td>
                                    <td width="95%">
                                        {this.state.value == 1 ? <></> : <>
                                            <button className={classes.button} disabled={this.state.value == 1 ? true : false} onClick={this.EditSave} ><img src={Save} style={{ marginTop: '-4px', opacity: this.state.value == 1 ? '0.5' : '1' }}></img>&nbsp;Save</button>
                                            <button className={`${classes.button} pl-3`} onClick={() => { this.EditCancelarrow() }} ><img src={Cancel} style={{ marginTop: '-4px' }}></img>&nbsp;Cancel</button>
                                            <button className={`${classes.button} pl-3`} disabled={this.state.value == 1 ? true : false} data-target="#deletepopup" data-toggle="modal" ><img src={Delete} style={{ marginTop: '-4px', opacity: this.state.value == 1 ? '0.5' : '1' }}></img>&nbsp;Delete</button>
                                        </>}
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    }
                    <div style={{ margin: this.state.isMobile ? "0" : "5px" }}>
                        {this.state.isMobile ? <></> : <h6 className="col-12 mt-3 ml-2">Edit Operation Planning & Achievement</h6>}
                        <div className="row ">
                            <div >
                                <AppBar position="static" display="none" color="inherit" className={classes.root}>
                                    <Tabs
                                        value={this.state.value}
                                        onChange={this.handleChange}
                                        classes={{ indicator: classes.indicator }}
                                    >
                                        <Tab label="Details" className="px-1 ml-4" style={{ textTransform: "none", minWidth: '13px' }} {...a11yProps(0)} />
                                        <Tab label="History log" className="" style={{ textTransform: "none", minWidth: '13px' }}{...a11yProps(1)} />
                                    </Tabs>
                                </AppBar>
                                <TabPanel value={this.state.value} index={0}>
                                    <div>
                                        <div className={this.state.isMobile ? "row px-0 mt-n3" : "row px-2 mt-n3"}>
                                            <div className={`row  mx-0 align-items-center ${this.state.isMobile ? "" : "text-row"}`}>
                                                <div className={`col-12 col-sm-12  col-lg-2 col-xl-1 mt-2 ${this.state.isMobile ? "border-left border-right border-top col-md-12" : "col-md-2 px-0"}`}>
                                                    <label className={this.state.isMobile ? "d-flex pt-2" : "float-end text-right d-flex"}>Activity&nbsp;:
                                                        <div className={`${classes.helperText}`}>
                                                            <div className="MuiFormHelperText-contained">*</div>
                                                        </div></label>
                                                </div>
                                                <div className={`col-12 col-sm-12 col-lg-4 col-xl-3  ${this.state.isMobile ? "border-left border-right border-bottom col-md-12 pt-1 pb-3" : "col-md-4 pt-4 pb-4"}`}>
                                                    {this.state.ActivityError ?
                                                        <div className="autocomplete-wrappers">
                                                            <Autocomplete
                                                                contentEditable={true}
                                                                value={this.state.addData.Activity}
                                                                inputProps={{
                                                                    placeholder: "Activity",
                                                                }}
                                                                items={OPA_Actvity ?? []}
                                                                getItemValue={(item) => item.Name}
                                                                shouldItemRender={this.renderProjectNames.bind(this)}
                                                                renderMenu={(item) => (
                                                                    <div className="dropdowns d-block" >{item}</div>
                                                                )}
                                                                renderInput={(props) => {
                                                                    return (
                                                                        <input
                                                                            className="form-control border-radius"
                                                                            id="exampleFormControlInput1"
                                                                            {...props}
                                                                            style={{ height: 32, fontSize: 12, color: "#000000", borderColor: 'red' }}
                                                                        />
                                                                    );
                                                                }}
                                                                renderItem={(item, isHighlighted) => (
                                                                    <div
                                                                        className={`items 
                                          ${isHighlighted ? "selected-items" : ""
                                                                            }`}
                                                                    >
                                                                        {item.Name}
                                                                    </div>
                                                                )}
                                                                onChange={(e) => this.handleProjectNameSearchChange(e)}
                                                                onSelect={(e) => this.handleProjectNameSelectChange(e)}
                                                            />
                                                        </div> :
                                                        <div className=" autocomplete-wrappers">
                                                            <Autocomplete
                                                                contentEditable={true}
                                                                value={this.state.addData.Activity}
                                                                inputProps={{
                                                                    placeholder: "Activity",
                                                                }}

                                                                items={OPA_Actvity ?? []}
                                                                getItemValue={(item) => item.Name}
                                                                shouldItemRender={this.renderProjectNames.bind(this)}
                                                                renderMenu={(item) => (
                                                                    <div className="dropdowns d-block" >{item}</div>
                                                                )}

                                                                renderInput={(props) => {
                                                                    return (
                                                                        <input
                                                                            className="form-control border-radius"
                                                                            id="exampleFormControlInput1"
                                                                            {...props}
                                                                            style={{ width: '100%', height: 35, fontSize: 12, color: "#000000" }}
                                                                        />
                                                                    );
                                                                }}
                                                                renderItem={(item, isHighlighted) => (
                                                                    <div
                                                                        className={`items 
                         ${isHighlighted ? "selected-items" : ""
                                                                            }`}
                                                                    >
                                                                        {item.Name}
                                                                    </div>
                                                                )}
                                                                onChange={(e) => this.handleProjectNameSearchChange(e)}
                                                                onSelect={(e) => this.handleProjectNameSelectChange(e)}
                                                            />

                                                        </div>

                                                    }
                                                </div>

                                                <div className={`col-12 col-sm-12  col-lg-2 col-xl-1  ${this.state.isMobile ? "border-left border-right" : "mt-2 col-md-2 px-0"}`}>
                                                    <label className={this.state.isMobile ? "d-flex pt-2" : "text-right float-end d-flex d-flex"}>Planned Date&nbsp;:
                                                        <div className={`${classes.helperText}`}>
                                                            <div className="MuiFormHelperText-contained">*</div>
                                                        </div></label>
                                                </div>
                                                <div className={`col-12 col-sm-12 col-lg-4 col-xl-3  ${this.state.isMobile ? "border-left border-right border-bottom col-md-12 pt-1 pb-3" : "col-md-4 pt-4 pb-4"}`}>
                                                    {this.state.PlannedDateError ?
                                                        <TextField
                                                            type="date"
                                                            variant="outlined"
                                                            size="small"
                                                            fullWidth
                                                            error
                                                            id="type-date"
                                                            value={this.state.addData.PlannedDate && moment(this.state.addData.PlannedDate).format("yyyy-MM-DD")}
                                                            placeholder={this.state.addData.PlannedDate && moment(this.state.addData.PlannedDate).format(this.props.settings.Convention ? this.props.settings.Convention : "DD/MM/YYYY")}
                                                            onChange={(e) => { this.handleDateChange(e, "PlannedDate") }}
                                                            InputProps={{
                                                                className: `border-radius ${classes.inputfieldAlign}`
                                                            }}
                                                            inputProps={{
                                                                max: `${JSON.parse(localStorage.getItem('BasicInfo')) && (JSON.parse(localStorage.getItem('BasicInfo')).Status.toLowerCase() == 'completed' ? moment(JSON.parse(localStorage.getItem('BasicInfo')).ProjectCompletionDate).format("yyyy-MM-DD") : JSON.parse(localStorage.getItem('BasicInfo')).ExtensionDate != null ? moment(JSON.parse(localStorage.getItem('BasicInfo')).ExtensionDate).format("yyyy-MM-DD") : moment(JSON.parse(localStorage.getItem('BasicInfo')).EstimatedCompletionDate).format("yyyy-MM-DD"))}`,
                                                                min: `${JSON.parse(localStorage.getItem('BasicInfo')) && moment(JSON.parse(localStorage.getItem('BasicInfo')).ProjectStartDate).format("yyyy-MM-DD")}`,
                                                              }}
                                                        />
                                                        :
                                                        <TextField
                                                            type="date"
                                                            variant="outlined"
                                                            size="small"
                                                            fullWidth
                                                            id="type-date"
                                                            value={this.state.addData.PlannedDate && moment(this.state.addData.PlannedDate).format("yyyy-MM-DD")}
                                                            placeholder={this.state.addData.PlannedDate && moment(this.state.addData.PlannedDate).format(this.props.settings.Convention ? this.props.settings.Convention : "DD/MM/YYYY")}
                                                            onChange={(e) => { this.handleDateChange(e, "PlannedDate") }}
                                                            InputProps={{
                                                                className: `border-radius ${classes.inputfieldAlign}`
                                                            }}
                                                            inputProps={{
                                                                max: `${JSON.parse(localStorage.getItem('BasicInfo')) && (JSON.parse(localStorage.getItem('BasicInfo')).Status.toLowerCase() == 'completed' ? moment(JSON.parse(localStorage.getItem('BasicInfo')).ProjectCompletionDate).format("yyyy-MM-DD") : JSON.parse(localStorage.getItem('BasicInfo')).ExtensionDate != null ? moment(JSON.parse(localStorage.getItem('BasicInfo')).ExtensionDate).format("yyyy-MM-DD") : moment(JSON.parse(localStorage.getItem('BasicInfo')).EstimatedCompletionDate).format("yyyy-MM-DD"))}`,
                                                                min: `${JSON.parse(localStorage.getItem('BasicInfo')) && moment(JSON.parse(localStorage.getItem('BasicInfo')).ProjectStartDate).format("yyyy-MM-DD")}`,
                                                              }}
                                                        />
                                                    }
                                                </div>
                                                <div className={`col-12 col-sm-12  col-lg-2 col-xl-1  ${this.state.isMobile ? "border-left border-right" : "mt-2 col-md-2"}`}>
                                                    <label className={this.state.isMobile ? "pt-2" : "text-right float-end d-flex"}>Date of Completion&nbsp;:</label>
                                                </div>
                                                <div className={`col-12 col-sm-12 col-lg-4 col-xl-3  ${this.state.isMobile ? "border-left border-right border-bottom col-md-12 pt-1 pb-3" : "col-md-4 pt-4 pb-4"}`}>
                                                    <TextField
                                                        type="date"
                                                        variant="outlined"
                                                        size="small"
                                                        fullWidth
                                                        id="type-date"
                                                        value={this.state.addData.CompletionDate && moment(this.state.addData.CompletionDate).format("yyyy-MM-DD")}
                                                        placeholder={this.state.addData.CompletionDate && moment(this.state.addData.CompletionDate).format(this.props.settings.Convention ? this.props.settings.Convention : "DD/MM/YYYY")}
                                                        onChange={(e) => { this.handleDateChange(e, "CompletionDate") }}
                                                        InputProps={{
                                                            className: `border-radius ${classes.inputfieldAlign}`
                                                        }}
                                                        inputProps={{
                                                            max: `${JSON.parse(localStorage.getItem('BasicInfo')) && (JSON.parse(localStorage.getItem('BasicInfo')).Status.toLowerCase() == 'completed' ? moment(JSON.parse(localStorage.getItem('BasicInfo')).ProjectCompletionDate).format("yyyy-MM-DD") : JSON.parse(localStorage.getItem('BasicInfo')).ExtensionDate != null ? moment(JSON.parse(localStorage.getItem('BasicInfo')).ExtensionDate).format("yyyy-MM-DD") : moment(JSON.parse(localStorage.getItem('BasicInfo')).EstimatedCompletionDate).format("yyyy-MM-DD"))}`,
                                                            min: `${JSON.parse(localStorage.getItem('BasicInfo')) && moment(JSON.parse(localStorage.getItem('BasicInfo')).ProjectStartDate).format("yyyy-MM-DD")}`,
                                                          }}
                                                    />
                                                </div>
                                            </div>
                                            <div className={`row mx-0 align-items-center ${this.state.isMobile ? "" : "border-left border-right border-bottom"}`}>

                                                <div className={`col-12 col-sm-12  col-lg-2 col-xl-1  ${this.state.isMobile ? "border-left border-right" : this.state.addData.CompletionDate == null ? "mt-n4 col-md-2" : " mt-n4 col-md-2 px-0"}`}>
                                                    {this.state.addData.CompletionDate == null ? <>
                                                        <label className={this.state.isMobile ? "pt-2" : "text-right m-0"}>Reasons for Deviation&nbsp;:</label>
                                                    </>
                                                        :
                                                        <><label className={this.state.isMobile ? "d-flex pt-2" : "text-right float-end d-flex m-0"}>Reasons for Deviation&nbsp;:
                                                            <div className={`${classes.helperText}`}>
                                                                <div className="MuiFormHelperText-contained">*</div>
                                                            </div></label></>}
                                                </div>
                                                <div className={`col-12 col-sm-12 col-xl-11 col-lg-10  ${this.state.isMobile ? "border-left border-right border-bottom col-md-12 pt-1" : "col-md-10 pt-4"}`}>
                                                    {this.state.ReasonsForDeviationError ?
                                                        <TextField
                                                            multiline
                                                            rows={4}
                                                            variant="outlined"
                                                            size="small"
                                                            fullWidth
                                                            value={this.state.addData.ReasonsForDeviation}
                                                            onChange={(e) => { this.handleCommentChange(e, "ReasonsForDeviation") }}
                                                            error
                                                            InputProps={{
                                                                className: `border-radius ${classes.inputfieldAlign}`
                                                            }}
                                                        /> :
                                                        <TextField
                                                            multiline
                                                            rows={4}
                                                            variant="outlined"
                                                            size="small"
                                                            value={this.state.addData.ReasonsForDeviation}
                                                            onChange={(e) => { this.handleCommentChange(e, "ReasonsForDeviation") }}
                                                            fullWidth
                                                            InputProps={{
                                                                className: `border-radius ${classes.inputfieldAlign}`
                                                            }}
                                                        />}
                                                    <label className="float-end pt-2" style={{ opacity: '0.5' }}>{this.state.addData?.ReasonsForDeviation?.length == undefined ? 500 - 0 : 500 - this.state.addData.ReasonsForDeviation?.length}/500 Characters left</label>
                                                </div>
                                            </div>
                                            <div className={`row mx-0 align-items-center ${this.state.isMobile ? "" : "border-left border-right border-bottom"}`}>
                                                <div className={`col-12 col-sm-12  col-lg-2 col-xl-1  ${this.state.isMobile ? "border-left border-right" : "mt-n4 col-md-2 px-0"}`}>
                                                    <label className={this.state.isMobile ? "pt-2" : "text-right float-end float-end"}>Comments&nbsp;:</label>
                                                </div>
                                                <div className={`col-12 col-sm-12 col-xl-11 col-lg-10  ${this.state.isMobile ? "border-left border-right border-bottom col-md-12 pt-1" : "col-md-10 pt-4"}`}>
                                                    <TextField
                                                        multiline
                                                        rows={8}
                                                        variant="outlined"
                                                        size="small"
                                                        value={this.state.addData.Comments}
                                                        onChange={(e) => { this.handleCommentChange(e, "Comments") }}
                                                        fullWidth
                                                        InputProps={{
                                                            className: `border-radius ${classes.inputfieldAlign}`
                                                        }}
                                                    />
                                                    <label className="float-end pt-2" style={{ opacity: '0.5' }}>{this.state.addData?.Comments?.length == undefined ? 1000 - 0 : 1000 - this.state.addData?.Comments?.length}/1000 Characters left</label>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </TabPanel>
                                <TabPanel value={this.state.value} index={1}>
                                    <div className="row">
                                        <div className="mt-n3">
                                            <div className="col-sm-12 col-12 px-0">
                                                <div className="table-responsive mb-4" style={{ width: "100%" }}>
                                                    <table id="dataTable" className="table">
                                                        <thead>
                                                            <tr className="">
                                                                <th className="border-top border-right border-left" style={{ width: '15%', minWidth: '170px' }}><span className="spandoc-thead" style={{ color: "#000000" }}>Timestamp</span></th>
                                                                <th className="border-top border-right" style={{ width: '6%', minWidth: window.innerWidth < 1000 ? '80px' : "" }}><span className="spandoc-thead" style={{ color: "#000000" }}>Action</span></th>
                                                                <th className="border-top border-right" style={{ width: '15%', minWidth: window.innerWidth < 1000 ? '135px' : "" }}><span className="spandoc-thead" style={{ color: "#000000", whiteSpace: 'nowrap' }}>Action by</span></th>
                                                                <th className="border-top border-right" style={{ width: '64%', minWidth: window.innerWidth < 1000 ? '400px' : "" }}><span className="spandoc-thead" style={{ color: "#000000" }}>Comments</span></th>
                                                            </tr>
                                                        </thead>
                                                        <tbody style={{ fontFamily: 'Segoe UI' }}>
                                                            {this.props.historyLog && this.props.historyLog.map((i) => (
                                                                <tr>
                                                                    <td className="spandoc-td border-right border-left align-middle">
                                                                        {moment(i.TimeStamp).format(this.props.settings.Convention ? this.props.settings.Convention + " hh:mm:ss A" : "DD/MM/YYYY hh:mm:ss A")}
                                                                    </td>
                                                                    <td className="spandoc-td border-right align-middle">{i.Action}</td>
                                                                    <td className="spandoc-td border-right align-middle">{i.ActionBy}</td>
                                                                    <td className="spandoc-td border-right align-middle">{i.Comments}</td>
                                                                </tr>
                                                            ))}
                                                        </tbody>
                                                    </table>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </TabPanel>
                            </div>
                        </div>
                    </div>
                    <div class="modal fade p-5 mt-5" id="deletepopup" tabindex="-1" role="dialog" aria-labelledby="deletepopupLabel" aria-hidden="true" style={{ top: "13%", left: this.state.isMobile ? "2%" : menuToggle ? "10%" : "" }}>
                        <div class="modal-dialog" role="document">
                            <div class={this.state.isMobile ? "modal-content" : "modal-content p-3"}>
                                <div class="modal-body pb-0">
                                    <h1 className="text-center">
                                        <img src={del}></img>
                                    </h1>
                                    <div className="text-center">
                                        <h5 class="fw-bold">Are you sure you want to delete?</h5>  </div>
                                </div>
                                <div class="modal-footer border-top-0 m-auto">
                                    <button type="button" class={this.state.isMobile ? "btn btn-secondary" : " btn btn-secondary py-2 px-4"} data-dismiss="modal" style={{ backgroundColor: "#00838F", border: "none" }} onClick={this.DeleteItem}><span className="" >Delete</span></button>
                                    <button type="button" id="closemodal" class={this.state.isMobile ? "btn btn-secondary" : " btn btn-secondary py-2 px-4"} data-dismiss="modal" style={{ backgroundColor: "#EBEBEB", border: "none", color: "#111010" }}><span className="" >Cancel</span></button>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="modal fade p-5 mt-5" id="cancelpopup" tabindex="-1" role="dialog" aria-labelledby="cancelpopupLabel" aria-hidden="true" style={{ top: "13%", left: this.state.isMobile ? "2%" : menuToggle ? "10%" : "" }}>
                        <div class="modal-dialog" role="document">
                            <div class={this.state.isMobile ? "modal-content" : "modal-content p-3"}>
                                <div class="modal-body pb-0">
                                    <h1 className="text-center">
                                        <img src={del}></img>
                                    </h1>
                                    <div className="text-center">
                                        <h5 class="fw-bold">The data will be lost. Do you really want to cancel?</h5> </div>
                                </div>
                                <div class="modal-footer border-top-0 m-auto">
                                    <button type="button" class={this.state.isMobile ? "btn btn-secondary" : " btn btn-secondary py-2 px-4"} data-dismiss="modal" style={{ backgroundColor: "#00838F", border: "none" }} onClick={this.EditCancel}><span className="" >Yes</span></button>
                                    <button type="button" id="closemodal1" class={this.state.isMobile ? "btn btn-secondary" : " btn btn-secondary py-2 px-4"} onClick={() => window.$("#cancelpopup").modal("hide")} style={{ backgroundColor: "#EBEBEB", border: "none", color: "#111010" }}><span className="" >No</span></button>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="modal fade p-5 mt-5" id="cancelpopup1" tabindex="-1" role="dialog" aria-labelledby="cancelpopupLabel" aria-hidden="true" style={{ top: "13%", left: this.state.isMobile ? "2%" : menuToggle ? "10%" : "" }}>
                        <div class="modal-dialog" role="document">
                            <div class={this.state.isMobile ? "modal-content" : "modal-content p-3"}>
                                <div class="modal-body pb-0">
                                    <h1 className="text-center">
                                        <img src={del}></img>
                                    </h1>
                                    <div className="text-center">
                                        <h5 class="fw-bold">The data will be lost. Do you really want to cancel?</h5> </div>
                                </div>
                                <div class="modal-footer border-top-0 m-auto">
                                    <button type="button" class={this.state.isMobile ? "btn btn-secondary" : " btn btn-secondary py-2 px-4"} data-dismiss="modal" style={{ backgroundColor: "#00838F", border: "none" }} onClick={this.SideBarCancel}><span className="" >Yes</span></button>
                                    <button type="button" id="closemodal1" class={this.state.isMobile ? "btn btn-secondary" : " btn btn-secondary py-2 px-4"} onClick={() => window.$("#cancelpopup1").modal("hide")} style={{ backgroundColor: "#EBEBEB", border: "none", color: "#111010" }}><span className="" >No</span></button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </>
        );
    }
}
function mapDispatchToProps(dispatch) {
    return {
        dispatch,
    };
}

function mapStateToProps(state) {
    return {
        menuToggle: state.commonReducer.menuToggle,
        sharedopadata: state.OPAReducer.sharedopadata || [],
        erroropapass: state.OPAReducer.erroropapass || [],
        OPA_Actvity: state.MasterDataReducer.Lookup_data || [],
        settings: state.commonReducer.settings || [],
        historyLog: state.commonReducer.historyLog || [],
    };
}

EditOPA.propTypes = {
    classes: PropTypes.object.isRequired,
}
export default withRouter(
    connect(mapStateToProps, mapDispatchToProps)(withStyles(styles)(EditOPA))
);

